import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DB, REAL_DB } from '../firebase'
import firebase from 'firebase'
import { useAuthContext } from './contexts/AuthContext'
import ZoomingAnimation from './partials/ZoomingAnimation'
import { tsToDate } from './utils/tsToDate'
import { useHistory } from 'react-router-dom'
import { navDirections } from './utils/navDirections'
import { useGeneralContext } from './contexts/GeneralContext'

function Exams() {
    const [loading, setLoading] = useState(true)
    const [exams, setExams] = useState([])

    const { userDetails } = useAuthContext()
    const { setExamSelected, createTimeStampInDB } = useGeneralContext()

    const history = useHistory()

    const cardBackgrounds = [
        'linear-gradient(167.6deg, #ff5a8e -9.78%, #fc7563 107.04%)',
        'linear-gradient(177.23deg, #bf6cff -13.49%, #6772fc 109.75%)',
        'linear-gradient(178.76deg, #36c687 1%, #039c59 97.45%)'
    ]

    const handleExamClicks = (xm) => {
        setExamSelected(xm)
        history.push(navDirections.EXAMS_INSTRUCTIONS)
        // history.push(navDirections.EXAMS_INSTANT_RESULT)
    }

    async function filterExams(examList = []) {
        const dbRef = REAL_DB.ref()
        setExams([])

        await createTimeStampInDB()

        await dbRef
            .child('timestamps')
            .child(userDetails?.uid)
            .on('value', (snapshot) => {
                const data = snapshot.val()
                let ar = []
                examList.forEach((el) => {
                    if (
                        el?.timeAtReal + el?.duration * 60 * 1000 >
                        data.timestamp
                    ) {
                        ar.push(el)
                    }
                })
                setExams(ar)
                setLoading(false)
            })
    }

    useEffect(async () => {
        setLoading(true)
        const today = new Date()
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)

        let listener

        if (!!userDetails?.batch?.batchName)
            listener = DB.collection('onlineExams')
                .where(
                    'batches',
                    'array-contains',
                    userDetails?.batch?.batchName
                )
                .where('disabled', '==', false)
                .where(
                    'time',
                    '>=',
                    new firebase.firestore.Timestamp.fromDate(yesterday)
                )
                .orderBy('time', 'desc')
                .onSnapshot((querySnapshot) => {
                    let arr = []
                    querySnapshot.forEach((doc) => {
                        if (!!doc.data()?.[userDetails?.uid] !== true)
                            arr.push({
                                ...doc.data(),
                                id: doc.id
                            })
                    })
                    filterExams(arr)
                })

        return () => listener
    }, [])

    return (
        <ExamsContainer>
            <Heading>Exams</Heading>

            <ExamCardContainer>
                {!!exams?.length &&
                    exams?.map((item, key) => (
                        <ExamCard
                            onClick={() => handleExamClicks(item)}
                            key={key}
                            background={cardBackgrounds[key % 3]}
                        >
                            <ExamCardSubject>{item?.subject}</ExamCardSubject>
                            <ExamCardTitle>{item?.title}</ExamCardTitle>
                            <ExamTimeSection>
                                <ExamTime>{tsToDate(item?.time)[1]}</ExamTime>
                                <ExamTime>{tsToDate(item?.time)[2]}</ExamTime>
                            </ExamTimeSection>
                        </ExamCard>
                    ))}
            </ExamCardContainer>

            {loading && !!!exams.length && <ZoomingAnimation />}
            {!loading && !!!exams.length && (
                <NotAvailable>No More Exams Available</NotAvailable>
            )}
        </ExamsContainer>
    )
}

const ExamsContainer = styled.div`
    padding-top: 4.5rem;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 24px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`
const ExamCardContainer = styled.div`
    margin: 40px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    max-width: 500px;
    width: 100%;
`
const ExamCard = styled.div`
    background: ${({ background }) => background};
    color: #fff;
    border-radius: 8px;
    padding: 20px;
    width: 100%;
    cursor: pointer;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    margin: 15px 0;
`
const ExamCardSubject = styled.p`
    font-weight: 600;
    text-align: center;
    color: #fff;
    font-size: 18px;
`
const ExamCardTitle = styled.p`
    font-weight: 500;
    text-align: left;
    color: #fff;
    font-size: 16px;
    margin: 10px 0;
    width: 100%;
`
const ExamTimeSection = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`
const ExamTime = styled.p`
    font-weight: 400;
    text-align: left;
    color: #fff;
    font-size: 15px;
`

const NotAvailable = styled.p`
    text-align: center;
    color: #fff;
    margin: 30px 0;
`

export default Exams
